import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import HeaderSection from "../home/homeHeader";
import LandlordTable from "../home/landlordTable";
import RenewelSection from "../home/leaseRenewel";
import MaintenanceRequest from "../home/maintenance";
import Landlord from "../home/pendingLandlord";
import PropertiesSection from "../home/propertiesHome";
import PropertyRegister from "../home/propertyRegister";
import Subscriptions from "../home/recentSubscription";
import RecordSection from "../home/record-section";
import TenantsSection from "../home/tenantHome";
import FlexWalletTile from "../home/flexWalletTile";

import BaseUrl from "../../../constants/BaseUrl";

const   HomeSection = ({
  onNotificationClick,
  createSupport,
  detailStaff,
  onViewDetailsLandlord,
  onLandlordApproval,
  onPropertyPage,
  onTenantList,
  onViewDetails,
  onViewDetailsMaintain,
  onMaintainanceTable,
  onViewDetailsProperty,
  onLandlordTable,
  onPendingLandlordTable,
  onSubscriptionsList,
}) => {
  const [allPendingLandlord, setPendingLandlord] = useState([]);
  const { loginSuccess } = useSelector((state) => state.auth);
  const [Stats, setStats] = useState();
  const [recentSubscriptions, setRecentSubscriptions] = useState([]);
  const [subscriptionStats, setSubscriptionStats] = useState();

  const GetAllPendingLanlord = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}landlord/profile/getLandlordProfileByStatus/sendForApproval`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "success") {
          setPendingLandlord(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  const GetAllStats = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${BaseUrl}superAdmin/auth/getSuperAdminStats`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setStats(result.data);

          // alert(result.data)
        }
      })
      .catch((error) => console.error(error));
  };

  const GetRecentSubscripion = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${BaseUrl}superAdmin/auth/getRecentSubscriptions`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setRecentSubscriptions(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  const GetSubscriptionStats = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${BaseUrl}superAdmin/auth/getSubscriptionStats`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setSubscriptionStats(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    GetAllPendingLanlord();
    GetAllStats();
    GetRecentSubscripion();
    GetSubscriptionStats();
  }, []);

  return (
    <div className="w-full mb-8">
      <HeaderSection onNotificationClick={onNotificationClick} />
      <RecordSection Stats={Stats} />
      <FlexWalletTile />

      <div className="flex justify-between">
        <div className="w-[50%]">
          <RenewelSection subscriptionStats={subscriptionStats} />
          <Subscriptions
            onViewAll={onSubscriptionsList}
            recentSubscriptions={recentSubscriptions}
          />
          <TenantsSection
            onTenantList={onTenantList}
            onViewDetails={onViewDetails}
          />
        </div>
        <div className="w-[49%]">
          <PropertyRegister Stats={Stats} />
          <Landlord
            allPendingLandlord={allPendingLandlord}
            onShowLandlordApproval={(item) => {
              onLandlordApproval(item);
            }}
            handleLandlordTable={onPendingLandlordTable}
          />
          <PropertiesSection
            onPropertyPage={onPropertyPage}
            onViewDetails={onViewDetailsProperty}
          />
        </div>
      </div>
      <LandlordTable
        onViewDetails={onViewDetailsLandlord}
        handleLandlordTable={onLandlordTable}
      />
      <MaintenanceRequest
        onViewDetails={onViewDetailsMaintain}
        onMaintainanceTable={onMaintainanceTable}
      />
      {/* <SupportStaff createSupport={createSupport} detailStaff={detailStaff} /> */}
    </div>
  );
};

export default HomeSection;
